interface DataConfig {
  key: string;
  graph: string;
  transform: (data: any, fullData?: any) => any;
  gridColDef?: any[];
}

export const chatAnalyticsDataConfigs: DataConfig[] = [
  {
    key: 'chat_statistics_overview.total_messages',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Messages',
      value: data?.toString() || '0',
      change: `${fullData.chat_statistics_overview?.date_range?.from || ''} to ${fullData.chat_statistics_overview?.date_range?.to || ''}`,
      changeType: 'positive',
      icon: 'ChatIcon',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accentColor: '#667eea'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_statistics_overview.total_group_messages',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Group Messages',
      value: data?.toString() || '0',
      change: `Peer: ${fullData.chat_statistics_overview?.total_peer_messages || 0}`,
      changeType: 'positive',
      icon: 'PeopleIcon',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      accentColor: '#4facfe'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_statistics_overview.total_peer_messages',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Peer Messages',
      value: data?.toString() || '0',
      change: `Group: ${fullData.chat_statistics_overview?.total_group_messages || 0}`,
      changeType: 'positive',
      icon: 'ChatIcon',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      accentColor: '#f093fb'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'messaging_activity_data',
    graph: 'AreaChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      sent: item.sent,
      delivered: item.delivered,
      read: item.read,
      total: item.total
    })) || []
  },
  {
    key: 'concurrent_message_sent_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'concurrent_message_delivered_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'concurrent_message_read_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_trends_data',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      group: item.group,
      user: item.user
    })) || []
  },
  {
    key: 'top_10_days_by_sent_messages',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      sent_count: item.sent_count
    })) || []
  },
  {
    key: 'message_type_distribution',
    graph: 'PieChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.name,
      value: item.count,
      color: item.color
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_statistics_overview.total_sent',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'Total Sent',
      value: data?.toString() || '0',
      change: 'Sent messages',
      changeType: 'positive',
      icon: 'TrendingUpIcon',
      gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      accentColor: '#fa709a'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_statistics_overview.total_delivered',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'Total Delivered',
      value: data?.toString() || '0',
      change: 'Delivered messages',
      changeType: 'positive',
      icon: 'TrendingUpIcon',
      gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
      accentColor: '#30cfd0'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  },
  {
    key: 'chat_statistics_overview.total_read',
    graph: 'MetricCard',
    transform: (data: any) => ({
      title: 'Total Read',
      value: data?.toString() || '0',
      change: 'Read messages',
      changeType: 'positive',
      icon: 'AccessTimeIcon',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accentColor: '#667eea'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "user_id", headerName: "User ID", width: 150 },
      { field: "user_name", headerName: "User Name", width: 150 },
      { field: "message_id", headerName: "Message ID", width: 150 },
      { field: "message_type", headerName: "Message Type", width: 150 },
      { field: "message_status", headerName: "Message Status", width: 150 },
      { field: "event_type", headerName: "Event Type", width: 150 },
      { field: "is_sent", headerName: "Sent", width: 150 },
      { field: "is_delivered", headerName: "Delivered", width: 150 },
      { field: "is_read", headerName: "Read", width: 150 },
      { field: "sent_at", headerName: "Sent At", width: 150 },
      { field: "delivered_at", headerName: "Delivered At", width: 150 },
      { field: "read_at", headerName: "Read At", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "group_name", headerName: "Group Name", width: 150 },
      { field: "group_type", headerName: "Group Type", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 }
    ]
  }
];